import { lazy } from "react";
import Loadable from "app/components/Loadable";

const PaymentGatewayList = Loadable(
  lazy(() => import("./PaymentGatewayConfigList")),
);
const PaymentGatewayAdd = Loadable(
  lazy(() => import("./PaymentGatewayConfigAdd")),
);

const PaymentGatewayRoutes = [
  { path: "/billing/payment-gateway", element: <PaymentGatewayList /> },
  {
    path: "/billing/payment-gateway/:mode/:id",
    element: <PaymentGatewayAdd />,
  },
];

export default PaymentGatewayRoutes;
